import { connect } from "react-redux";
import PropTypes from "prop-types";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./LayoutTopSideBottom.scss";
import AdminSideNav from "../../components/Sidenav/AdminSideNav";

function AdminLayoutSideNav(props) {
  const { user, children, match } = props;
  return (
    <div className={`${user.theme} page`}>
      <Header match={match} />
      <section className="body">
        <AdminSideNav match={match} />
        <main className={`content full`}>{children}</main>
      </section>
      <Footer />
    </div>
  );
}

AdminLayoutSideNav.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(AdminLayoutSideNav);
